export const HomeBusinessStatement = () => {
  return (
    <section data-testid="home-business-statement" className="bg-[#F2F9F5] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 sm:py-24">
        <div className="max-w-3xl">
          <h2
            data-testid="home-business-statement-title"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#042D1F]"
          >
            Quality Products. Reliable Supply. Global Business.
          </h2>
          <p
            data-testid="home-business-statement-paragraph-1"
            className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed"
          >
            RKG NATURALS connects quality Indian agricultural and natural products with buyers seeking reliable
            sourcing and supply solutions.
          </p>
          <p
            data-testid="home-business-statement-paragraph-2"
            className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed"
          >
            We support agricultural product sourcing for wholesale, import, export and business requirements
            according to product availability and buyer specifications.
          </p>
        </div>
      </div>
    </section>
  );
};
